// extracted by mini-css-extract-plugin
export default {"mockLocation":"MockLocation_mockLocation__CToES","info":"MockLocation_info__TEfbB","close":"MockLocation_close__4fteD"};